import { TransmissionTowerIcon } from './TransmissionTowerIcon';

/**
 * author: Michael Irigoyen
 * id DBA97655-B2ED-4FA6-95E0-02E7273549C9
 * name transmission-tower
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transmission-tower.svg
 * tags
 * - Home Automation 
 */
export const PowerlineIcon = TransmissionTowerIcon;
export default PowerlineIcon